import { inject, Injectable } from '@angular/core';

import { FieldInterventionBloc } from '@connect-services/client/blocs/field-intervention.bloc';
import { MapBaseSource, MapComponent } from '@connect-services/client/components/map/map.component';
import { FieldInterventionMapModeService } from '@connect-services/client/services/field-intervention-map-mode.service';
import {
    FIELD_INTERVENTION_AREA_MASK_ID,
    MapMaskService,
} from '@connect-services/client/services/map/mask/map-mask.service';
import { MapSourceService } from '@connect-services/client/services/map-source.service';
import { SourcesService } from '@connect-services/client/services/sources.service';

@Injectable({
    providedIn: 'root',
})
export class FieldInterventionMapRendererService {
    private readonly fieldInterventionBloc = inject(FieldInterventionBloc);
    private readonly fieldInterventionMapModeService = inject(FieldInterventionMapModeService);
    private readonly mapMaskService = inject(MapMaskService);
    private readonly mapSourceService = inject(MapSourceService);
    private readonly sourcesService = inject(SourcesService);

    public async drawSourcesWithAreaMask(
        sources: MapBaseSource<unknown>[] = this.sourcesService.sources(),
        options: { fitBounds?: boolean } = {},
    ): Promise<void> {
        this.sourcesService.sources.set(sources);

        this.mapSourceService.clearSources(MapComponent.backgroundSource(), []);

        await this.mapSourceService.drawSources(sources, {
            fitBounds: options.fitBounds ?? true,
        });

        this.showAreaMask(sources);
    }

    public showAreaMask(sources: MapBaseSource<unknown>[] = this.sourcesService.sources()): void {
        if (!this.fieldInterventionMapModeService.shouldShowFieldInterventionAreaMask()) {
            return;
        }

        const fieldInterventionArea = this.fieldInterventionBloc.value()?.fieldInterventionArea;
        if (!fieldInterventionArea) {
            this.mapMaskService.clearMasks();

            return;
        }

        this.mapMaskService.applyMask(
            {
                area: fieldInterventionArea,
                id: FIELD_INTERVENTION_AREA_MASK_ID,
                showMask: true,
            },
            {
                businessSourceIds: sources.map((source) => source.sourceId),
                hideOuterEntities: true,
            },
        );
    }
}
